<!-- ── PENDING: eligibility check ─────────────────────────────────────────── -->
<div *ngIf="project.sop_status == 'pending'" class="action-panel">
  <div class="action-panel-header">Eligibility Check</div>
  <div class="action-panel-body">
    <p class="action-panel-desc">
      This project is in pending state and will stay so until a Call Manager evaluates it.
    </p>

    <div *ngIf="auth.isCallManager()" class="eligibility-row">
      <span class="eligibility-label" [class.is-eligible]="checked" [class.is-not-eligible]="!checked">
        {{ checked ? 'Eligible' : 'Not Eligible' }}
      </span>
      <label class="toggle-switch">
        <input type="checkbox" (change)="change()" [checked]="checked">
        <span class="toggle-slider"></span>
      </label>
    </div>

    <button *ngIf="auth.isCallManager()" (click)="submitEligibility()" class="btn btn-primary action-btn">
      Submit
    </button>
  </div>
</div>

<!-- ── NOT ELIGIBLE ───────────────────────────────────────────────────────── -->
<div *ngIf="project.sop_status == 'not_eligible'" class="action-panel">
  <div class="action-panel-header">Evaluation Result</div>
  <div class="action-panel-body">
    <div class="status-badge-block">
      <span class="label label-danger status-label-lg">Not Eligible</span>
    </div>
    <p class="action-panel-desc">This project has been evaluated as not eligible.</p>
  </div>
</div>

<!-- ── ELIGIBLE ───────────────────────────────────────────────────────────── -->
<div *ngIf="project.sop_status == 'eligible'" class="action-panel">
  <div class="action-panel-header">Evaluation Result</div>
  <div class="action-panel-body">
    <div class="status-badge-block">
      <span class="label label-success status-label-lg">Eligible</span>
    </div>
    <p class="action-panel-desc">This project has been evaluated as eligible.</p>
  </div>
</div>

<!-- ── PROACTIVE ──────────────────────────────────────────────────────────── -->
<div *ngIf="project.sop_status == 'proactive'" class="action-panel">
  <div class="action-panel-header">Evaluation Result</div>
  <div class="action-panel-body">
    <div class="status-badge-block">
      <span class="label label-primary status-label-lg">ProActive</span>
    </div>
    <p class="action-panel-desc">This project has been moved to ProActive.</p>
    <button *ngIf="auth.isCallManager() || auth.isProjectBoard()"
            (click)="moveProjectToEligible()" class="btn btn-default action-btn action-btn--secondary">
      Move back to Eligible
    </button>
  </div>
</div>

<!-- ── NOTE (call manager / project board, non-pending) ──────────────────── -->
<div *ngIf="project.sop_status != 'pending' && (auth.isCallManager() || auth.isProjectBoard())"
     class="action-panel" style="margin-top: 12px;">
  <div class="action-panel-header">Internal Note</div>
  <div class="action-panel-body">
    <form (ngSubmit)="submitNote()" #noteForm="ngForm">
      <textarea class="form-control note-textarea"
                [(ngModel)]="note" name="note" rows="4"
                placeholder="Write a note about this project…"></textarea>
      <button type="submit" class="btn btn-default action-btn action-btn--secondary" style="margin-top: 8px;">
        Save Note
      </button>
    </form>
  </div>
</div>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
